<template>
	<div class="huanbao2">
        <main>
            <span>猪场： </span>
            <el-select v-model="address" placeholder="请选择猪场">
                <el-option
                    v-for="(item,i) in options"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>

            <span>是否异常： </span>
            <el-select v-model="zhuangtai" placeholder="请选择" clearable>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="2"></el-option>
            </el-select>

            <span>巡查人：  </span>
            <el-input v-model="xuncharen" placeholder="巡查人" style="display:inline-block" clearable></el-input>
            <br/>
            <br/>

            <span >起止日期： </span>
            <el-date-picker
                style="width:338px"
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <el-button style="margin-left:56px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>
            <el-button type="info" icon="el-icon-download" @click="daochu()">导出</el-button>
        </main>
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    prop="create_time"
                    label="提交时间">
                </el-table-column>

                <el-table-column
                    prop="time"
                    label="巡查时间">
                </el-table-column>

                <el-table-column
                    prop="zhuchang"
                    label="猪场">
                </el-table-column>

                <el-table-column
                    prop="quyu"
                    label="巡查区域">
                </el-table-column>

                <el-table-column
                    prop="pinlv"
                    label="巡查频率">
                </el-table-column>
                
                <el-table-column
                    prop="yichang"
                    label="风险点">
                </el-table-column>

                <el-table-column prop="radio" label="是否异常">
                    <template slot-scope="scope">
                        <p>{{scope.row.radio == 1 ? '是': '否'}}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="巡查人">
                </el-table-column>

                <el-table-column
                    prop="beizhu"
                    label="描述">
                </el-table-column>

                <el-table-column
                    label="照片">
                    <template slot-scope="scope">
                        <span v-for="(item,i) in (scope.row.url).split(',')">
                            <el-popover
                                placement="bottom"
                                trigger="click">
                                <img :src="item" alt="" style="width:500px;height:500px">
                                <img :src="item" alt="" style="width:100px;height:100px;margin-right:20px" slot="reference" >
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

        </el-card>        


    </div>
</template>

<script>
    import option from "../config/option.js"
    import { powerList,url2 } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                tableData: [],
                options: [],
                address:'',
                zhuangtai:'',
                xuncharen:'',
                time:[],
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getUser()
            await this.getList()
        },
		methods: {
            search() {
                this.current_page = 1
                this.getList()
            },

            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list  = res.data[0].huanbao.split(',')
                    list.map(item=> {
                        this.options.push(item)
                    })
                    this.address = this.options[0]
                    if(this.address == '全部') {
                        this.options = option.huanbao
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },

          
            async getList() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }

                await this.axios.get(url2 + 'huanbaoSearch', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        zhuangtai:this.zhuangtai,
                        xuncharen:this.xuncharen,
                        zhuchang:this.address =='全部'? '':this.address,
                        time:'',
                        crate_time1:time1,
                        crate_time2:time2,
                    }
                }).then(res=> {
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                    loading.close();
                }).catch(err=> {
                    console.log(err);
                    loading.close();
                });
            },

            daochu() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url2 +'huanbaoSearch', {
                    params:{
                        export:1,
                        page:this.current_page,
                        per_page:this.per_page,
                        zhuangtai:this.zhuangtai,
                        xuncharen:this.xuncharen,
                        zhuchang:this.address =='全部'? '':this.address,
                        time:'',
                        crate_time1:time1,
                        crate_time2:time2,
                    },
                    responseType: 'blob',
                    
                }).then(res=> {
                    const data = res.data 
                    if (Object.prototype.toString.call(data) === '[object Blob]' && data.type.includes('application/vnd.ms-excel')) { 
                        const blob = res.data
                        const a = document.createElement('a')
                        let binaryData = [];
                        binaryData.push(blob);
                        const url= window.URL.createObjectURL(new Blob(binaryData));
                        a.href = url
                        a.download = '下载.csv'
                        a.click()
                        window.URL.revokeObjectURL(url)
                    }else{
                        this.$message.error('下载失败')
                    }
                    loading.close();
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },

        }

    }
</script>

<style scoped="scoped" lang='less'>
    .huanbao2 {
        padding: 0 10px;
        span {
            font-size: 12px;
        }
    }
    .huanbao2 .el-input {
        width:140px;
        margin-right: 20px;
    }

    .huanbao2 .el-select {
        width:140px;
        margin-right: 20px;
    }
    .huanbao2 main {
        margin-bottom: 20px;
    }
    .huanbao2 .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>